const env = process.env.REACT_APP_ENV;

const config = require(`./env/${env}`).default;

export default config;